<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
پلن های عضویت سمینار        </a-button>

        <a-modal width="1000px" v-model="visible" title=" پلن های عضویت سمینار" on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>

            </template>
            <form @submit.prevent="addData($event)">

              <div class="row">
                  <div class="col-md-4">
                      <div class="form-group text-right">
                          <label for=""> درصد هدیه</label>
                          <input v-model="plan.profit_percent" name="profit_percent" type="number" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group text-right">
                          <label for=""> تا  هزینه</label>
                          <input v-model="plan.money_max" name="money_max" type="number" class="form-control">
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group text-right">
                          <label for=""> از  هزینه</label>
                          <input v-model="plan.money_min" name="money_min" type="number" class="form-control">
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group text-right">
                    <label for=""> درصد سود روز شمار</label>
                    <input v-model="plan.daily_profit_percent" name="daily_profit_percent" type="number" class="form-control">
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="form-group text-right">
                    <label for="">توضیحات</label>
                    <input v-model="plan.description" name="description" type="text" class="form-control">
                  </div>
                </div>
              </div>
              <input name="seminar_id" type="hidden" :value="seminar.id">
              <div class="mt-1">
                <button type="submit"  class="btn btn-fill btn-outline-success ">
                  ذخیره
                </button>
              </div>
            </form>
            <hr>
            <div>
                <table class="table text-center">
                    <thead>
                        <tr>
                            <th scope="col">حذف</th>
                            <th scope="col">توضیحات</th>
                            <th scope="col"> درصد سود روز شما</th>
                            <th scope="col"> درصد هدیه</th>
                            <th scope="col"> تا  هزینه</th>
                            <th scope="col">  از هزینه</th>
                            <th scope="col">شناسه</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="plan in seminar.plans">
                            <td>
                                 <a-button class="btn-outline-warning" icon="delete" type="link"
                                @click="deleteRow(plan.id)"></a-button>

                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark">{{ plan . description }}</b-badge>
                            </td>
                          <td>
                                <b-badge variant="light" class="text-dark">{{ plan . daily_profit_percent }} %</b-badge>
                            </td>
                          <td>
                                <b-badge variant="light" class="text-dark">{{ plan . profit_percent }} %</b-badge>
                            </td>
                             <td>
                                <b-badge variant="light" class="text-dark">{{ $root.number_format(plan . money_max) }}</b-badge>
                            </td>
                            <td>
                                <b-badge variant="light" class="text-dark">{{ $root.number_format(plan . money_min) }}</b-badge>
                            </td>
                             
                            <th scope="row">#{{ plan . id }}</th>


                        </tr>
                    </tbody>
                </table>
            </div>

        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            seminar: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                plan:{}
            };
        },
        methods: {
            addData(event) {
                let _this = this;
                let data = new FormData(event.target);
                _this.$root.loading = true;
                axios
                    .post("/seminars/plan", data)
                    .then(function(response) {
                        console.log(response)
                        _this.$root.loading = false;
                        _this.seminar.plans.push(response.data.data)
                        _this.plan={};
                        _this.$toast.success(" پلن سمینار با موفقیت افزوده شد");
                    })
                    .catch(function(err) {
                        _this.$root.loading = false;
                        _this.$root.handleAxiosError(err);
                    });
            },
            deleteRow(id) {
                this.$swal({
                    title: "آیا از حذف اطلاعات اطمینان دارید؟",
                    showDenyButton: true,
                    showCancelButton: false,
                    confirmButtonText: "بله",
                    denyButtonText: "لغو",
                }).then((result) => {
                    if (result.isConfirmed) {
                        let _this = this;
                        axios
                            .get(`seminars/plan/delete/${id}`)
                            .then(function(response) {
                                _this.seminar.plans = _this.seminar.plans.filter((e)=>e.id !== id )
                                _this.$toast.success("با موفقیت حذف شد.");
                            })
                            .catch(function(err) {
                              _this.$toast.error("عدم دسترسی!");
                              _this.$root.handleAxiosError(err);
                            });
                    }
                });
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
        },
    };
</script>
